<template>
  <div class='scroll-element-root' :class='classes'>
    <slot/>
  </div>
</template>

<script>
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue'

export default defineComponent({
  props: {
    bottom: {
      type: Boolean
    },
    forceShow: {
      type: Boolean
    },
    showInitially: {
      type: Boolean,
      default: false
    },
    bottomSlack: {
      type: Number,
      default: 8
    }
  },
  setup(props) {
    const isBottom = ref(false);
    const isTop = ref(false);
    const overflowing = ref(false);
    const lastPosition = ref(0);
    const directionBottom = ref(!props.showInitially);

    const handleScroll = (event)=>{
      const targetElement = event.target;
      overflowing.value = targetElement.scrollHeight - targetElement.offsetHeight;
      isBottom.value = overflowing.value - props.bottomSlack <= targetElement.scrollTop;
      isTop.value = targetElement.scrollTop <= props.bottomSlack;

      directionBottom.value = lastPosition.value < event.srcElement.scrollTop
      lastPosition.value = event.srcElement.scrollTop;
    }

    const shouldHide = computed(()=>{
      return (
        !props.forceShow 
        && (props.bottom ^ directionBottom.value)
        && !(props.bottom && isBottom.value)
        && !(!props.bottom && isTop.value)
        && !(props.bottom && isTop.value)
      )
      
    });

    const classes = computed(()=>({
      'bottom': props.bottom,
      'scroll-hide': shouldHide.value
    }))

    onMounted(()=>{
      const targetElement = document.body;
      targetElement.addEventListener('scroll', handleScroll);
      const main = document.getElementsByClassName('v-main')[0];
      if (main && props.bottom)
        main.classList.add('pb-12')
    })

    onUnmounted(()=>{
      const targetElement = document.body;
      targetElement.removeEventListener('scroll', handleScroll);
      const main = document.getElementsByClassName('v-main')[0];
      if (main && props.bottom)
        main.classList.remove('pb-12')
    })

    return { 
      handleScroll,
      classes
    }
  },
})
</script>

<style lang="scss" scoped>
.scroll-element-root {
  display: contents;

  &.scroll-hide.bottom > * {
    transform: translateY(100%) !important;
  }

  &.scroll-hide > * {
    transform: translateY(-100%) !important;
  }

  & > * {
    transition: transform .5s;
    transform: translateY(0%) !important;
  }
}

</style>